module.exports = __webpack_public_path__ + "static/toggl-hire-poster-190e4e908c2e34fb7b260d72279e0517.png";